import { useState, useEffect } from 'react';
import { getPlace } from '../places';

const usePlacesProvider = ({
  type,
  parentId,
  name,
  grandParentId,
  size = 1000,
  search,
  sortby,
  excludedGrandParentIds = [],
  includedIds = [],
  electionType
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const parentQuery = parentId ? `&parentid=${parentId}` : '';
    const grandParentQuery = grandParentId ? `&grandpaid=${grandParentId}` : '';
    const nameQuery = name ? `&name=${name}` : '';
    const searchQuery = search ? `&search=${search}` : '';
    const sizeQuery = `&size=${size}`;
    const sortbyQuery = sortby ? `&sortby=${sortby}` : '';
    const typeQuery = type ? `typeplace=${type}` : '';
    const excludedQuery = excludedGrandParentIds.reduce(
      (result, id) => `${result}&excludeid=${id}`,
      ''
    );
    const includedQuery = includedIds.reduce(
      (result, id) => `${result}&addid=${id}`,
      ''
    );

    const filter = includedQuery ? `page=0&size=1000&${includedQuery}` : `${typeQuery}${grandParentQuery}${parentQuery}${nameQuery}${sizeQuery}${searchQuery}&page=0${sortbyQuery}${excludedQuery}${includedQuery}`;

    getPlace({ filter, type, electionType }).then(response => {
      setData(response.content);
    });
  }, [type, parentId, name, grandParentId, search, sortby]);

  return { result: data };
};

export default usePlacesProvider;
